import ReactIcon from "../assets/icons/react.png";
import SpringIcon from "../assets/icons/spring.png";
import RailsIcon from "../assets/icons/rails.png";
import AngularIcon from "../assets/icons/angular.svg";
import NodeIcon from "../assets/icons/node.svg";
import PythonIcon from "../assets/icons/python.png";

export const skills_EN = [
  {
    active: false,
    show: true,
    skill: "react",
    img: ReactIcon,
    title: "ReactJs",
    level: 3,
    time: "Since february 2020 until now",
    description:
      "I have been learning and applying knowledge in React since February 2020, to date I continue with it and the truth is that it is my strongest point among all the technologies mentioned, I love it and I would like to continue learning it and putting it into practice in solutions that merit its use.",
  },
  {
    active: false,
    show: true,
    skill: "node",
    img: NodeIcon,
    title: "NodeJs",
    level: 1,
    time: "Free times",
    description:
      "It is a technology that I rarely learn and execute, but at the same time, it is a personal goal to learn and master the JavaScript stack, most of the projects that I start with ReactJs, are designed so that the Backend is developed in NodeJs, so that it is especially attractive for me to learn it and execute it at the basic level or the level of knowledge that I possess at the time",
  },
  {
    active: false,
    show: true,
    skill: "angular",
    img: AngularIcon,
    title: "Angular",
    level: 2,
    time: "From february 2019 to february 2020",
    description:
      "Angular was the first web language that I learned, I used it for a year while collaborating for my work at SCD, in 2021 I collaborated with a group of friends in the construction of a web application in this language, although I am not currently dedicated to it, my level of knowledge goes hand in hand with what I learned in ReactJs.",
  },
  {
    active: false,
    show: false,
    skill: "spring",
    img: SpringIcon,
    title: "Spring Boot",
    level: 1,
    time: "From february 2019 to february 2020",
    description:
      "The knowledge learned in spring boot was strong while collaborating for my work in SCD, however, I did not use it again after that work, so, although I know the syntax and can read code from this framework, it would need a short period learning to use it again.",
  },
  {
    active: false,
    show: false,
    skill: "rails",
    img: RailsIcon,
    title: "Ruby on Rails",
    level: 1,
    time: "From february 2020 a Diciembre del 2020",
    description:
      "Ruby on rails was an experience of a year in my collaboration in PiikApp, I did maintenance and features to an already created application that provides services to a company website, as in spring, I did not use it again, since I wanted to focus my future API's to the stack in Javascript.",
  },
  ,
  {
    active: false,
    show: true,
    skill: "python",
    img: PythonIcon,
    title: "Python",
    level: 1,
    time: "Free times",
    description:
      "Python develops it in learning times, it is the most recent that I have learned and currently develop small projects with the goal of making a subtage that feeds other projects.",
  },
];
